import { cn } from '@siliconx/shared/ui/utils';

// Shared text-input class used by submit.tsx and MakeModelPicker.tsx — was
// defined independently in both and had already drifted (SIL critique).
export function inputCls(hasError: boolean) {
  return cn(
    'h-10 w-full rounded-md border bg-card px-3 text-sm text-foreground outline-none',
    'disabled:cursor-not-allowed disabled:bg-muted disabled:text-muted-foreground',
    'focus:ring-2 focus:ring-brand-500',
    hasError ? 'border-red-400 focus:ring-red-400' : 'border-border focus:border-brand-500',
  );
}
